export default __webpack_public_path__ + "static/media/notCaptainBadge.9a0622ef.svg";